import React from 'react'

export const Home: React.FunctionComponent = () => {
  return <div>home</div>
}
